/* HH v11 mobile-only guard (<=767px). Desktop: does nothing. */
(function(){
  'use strict';
  var mq;try{mq=window.matchMedia('(max-width:767px)')}catch(e){return}
  var on=function(){return mq.matches};
  /* never enter 3D on mobile: capture-phase block on the 3D mode toggle */
  function block(e){
    if(!on())return;
    var t=e.target&&e.target.closest&&e.target.closest('[data-v4-t]');
    if(t){e.preventDefault();e.stopImmediatePropagation();e.stopPropagation()}
  }
  ['click','pointerup','keydown'].forEach(function(n){
    document.addEventListener(n,function(e){if(n==='keydown'&&e.key!=='Enter'&&e.key!==' ')return;block(e)},true);
  });
  /* if a desktop->mobile resize/rotate happens while in 3D, go back to 2D via the active thumbnail (hh-v4.js sel() -> to2d) */
  function back2d(){
    if(!on())return;
    var fig=document.querySelector('.hero-fig');
    if(!fig||fig.getAttribute('data-v4m')!=='3d')return;
    var th=fig.querySelector('.v4-th[aria-pressed="true"]')||fig.querySelector('.v4-th');
    if(th)th.click();
  }
  /* scroll hint on the list-filter pills */
  function fade(){
    var t=document.querySelector('#bench-now .tabs');if(!t)return;
    var r=on()&&t.scrollWidth-t.clientWidth>4&&t.scrollLeft<t.scrollWidth-t.clientWidth-4;
    var l=on()&&t.scrollLeft>4;
    t.classList.toggle('hh11-fade-r',!!r);t.classList.toggle('hh11-fade-l',!!l);
  }
  function bind(){
    var t=document.querySelector('#bench-now .tabs');
    if(t&&!t.__hh11){t.__hh11=1;t.addEventListener('scroll',fade,{passive:true})}
    fade();back2d();
  }
  function chg(){bind()}
  try{mq.addEventListener('change',chg)}catch(e){try{mq.addListener(chg)}catch(_){}}
  window.addEventListener('resize',function(){fade()},{passive:true});
  window.addEventListener('orientationchange',function(){setTimeout(chg,200)});
  var n=0,iv=setInterval(function(){bind();if(++n>40)clearInterval(iv)},250);
  document.addEventListener('DOMContentLoaded',bind);
  /* mode attribute changes (3D entered via any path) */
  try{new MutationObserver(back2d).observe(document.documentElement,{subtree:true,attributes:true,attributeFilter:['data-v4m']})}catch(e){}
})();
